// Configuração dinâmica da API
export function getApiUrl() {
  // Em desenvolvimento com Vite, usar caminho relativo (proxy configurado no vite.config.js)
  if (import.meta.env.DEV) {
    return '/api';
  }

  const baseUrl = (import.meta.env.VITE_API_URL || window.location.origin).replace(/\/$/, '');

  if (baseUrl.endsWith('/api')) {
    return baseUrl;
  }

  return `${baseUrl}/api`;
}

export const API_URL = getApiUrl();
